// Types
import { AuthenticationType, AuthenticationTypes, CapitalizedRoles } from "@Settings/types/Common/auth";
import { IKeyTrack, IKiosk, ILojack, IOneMicro } from "@Settings/types/administrationTools/model";

type AuthRoleStatus = {
	isLoggedIn: boolean;
	username: string;
	authType: AuthenticationType;
	role: CapitalizedRoles;
};

type TProviderRole = {
	role: string;
	authType: AuthenticationType;
	properties: string;
};

type TSelectedProvider = {
	provider: string;
	providerName: string;
	providerDBProperty: string;
	authRoleStatuses?: AuthRoleStatus[];
	authType?: AuthenticationType;
	role: CapitalizedRoles;
	auth: {
		roles: TProviderRole[];
		baseUrl: string;
		endpoint: string;
		httpMethod: string;
		properties: string;
	};
	imageUrl: string;
	isLoggedIn: boolean;
};

type CustomCredentials = Partial<AuthenticationTypes> & { operation: { role: string; eventType: string } };

type GPSProviders = ILojack;
type GPSSelectedProvider = GPSProviders & TSelectedProvider;

type KMSProviders = IKeyTrack & IOneMicro;
type KMSSelectedProvider = KMSProviders & TSelectedProvider;

type TGpsStore = {
	gpsStoreId: string;
	gpsStoreName: string;
	provider: string;
};

type TOneMicroStore = {
	id: number;
	name: string;
	kiosks: TOneMicroKiosk[];
};

type TOneMicroKiosk = {
	id: number;
	name: string;
};

enum EManagementSystem {
	DMS = "DMS",
	CRM = "CRM",
}

type TSelectedKiosk = { storeId: number; kioskId: number };

type TSwitchableItem = { label: string; storeId: number; value: IKiosk };

type IRequestClientAccessResponse = {
	providerName: string;
	approvalLink: string;
	error?: boolean;
	errorMessage?: string;
};

export { EManagementSystem };

export type {
	IRequestClientAccessResponse,
	AuthRoleStatus,
	CustomCredentials,
	GPSSelectedProvider,
	KMSSelectedProvider,
	TProviderRole,
	TSelectedProvider,
	TGpsStore,
	TOneMicroStore,
	TOneMicroKiosk,
	TSelectedKiosk,
	TSwitchableItem,
};
